import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const normalize = (name) => `icon-${ name.replace(/-/g, '_') }`;

const Icon = ({ name, className, ...props }) => (
  <span
    className={ classnames(className, 'icon', normalize(name)) }
    { ...props }
  />
);

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.oneOf([
    'answer',
    'assigned-to-me',
    'attachment',
    'assignee',
    'broken-leg',
    'character-book',
    'chevron-left',
    'chevron-right',
    'magnifier',
    'organization',
    'dots-menu',
    'circle-check-fill',
    'circle-info',
    'circle-x-fill',
    'cup-outline',
    'dropdown-chevron-fill',
    'globe',
    'exclamation',
    'exclamation-outline',
    'exclamation-triangle',
    'hourglass',
    'naked-x',
    'pencil',
    'phone-disconnect',
    'phone-rings',
    'play-rtl',
    'refresh',
    'signout-rtl',
    'check',
    'envelope2',
    'chat-bubbles',
    'cake',
    'chevron-down',
    'organization',
    'circle-question',
    'clock-outline',
    'female-avatar',
    'expand',
    'guardian',
    'globe',
    'globe-flat',
    'id-fill',
    'info-bubble',
    'male-avatar',
    'media-folder',
    'minus',
    'phone-clock',
    'phone-fill',
    'plus',
    'prescriptions',
    'audio-video-disabled',
    'disconnect-call',
    'no-patients',
    'pause',
    'resume-call',
    'rotate-left',
    'rotate-right',
    'reset',
    'call-on-hold',
    'reconnect-call',
    'unable-to-connect',
    'video-mic-permissions',
    'calendar',
    'circle-check-fill',
    'circle-x-fill',
    'clock',
    'consultations',
    'dropdown-chevron-fill',
    'reset',
    'rotate-left',
    'rotate-right',
    'settings',
    'stethoscope',
    'arrow-left',
    'arrow-right',
    'arrows-up-down',
    'avatar',
    'chevron-up',
    'consultation',
    'envelope-grey',
    'female',
    'hangout',
    'lock',
    'lockdown',
    'male',
    'mic-mute',
    'mic',
    'minus',
    'patient-info',
    'patients',
    'pdf-file',
    'jpg-file',
    'png-file',
    'phone',
    'phone-sms',
    'play',
    'play-video',
    'signout',
    'speaker-mute',
    'speaker',
    'symptoms',
    'trash',
    'vidcam-off',
    'vidcam',
    'canceled-call',
    'not-approved',
    'media-folder',
    'two-people',
    'customer-user',
    'filter-lines',
    'arrow-down',
    'arrow-up',
    'archive-drawer',
    'ended_call',
    'appointment-id',
    'service',
    'connected_dots',
    'envelope',
    'gender-unknown',
    'gender-other',
    'male-avatar',
    'appointment-info',
    'health-representative',
    'characters-shrink',
    'wheel-chair',
    'exclamation_outline',
    'my-account',
    'hung-up-arrow-down',
    'push-message',
    'layers',
    'checkboard',
    'connected-dots',
    'arrows-up-down',
  ]).isRequired,
};

Icon.defaultProps = {
  className: '',
};

export default Icon;
